module.exports = __webpack_public_path__ + "static/media/icon_location.99a55d0a.svg";